var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { InputText } from "primereact/inputtext";
/**
 * BeoInputText is a custom made InputText component.
 * It has a custom toggle to show/hide the input content (only for password fields).
 *
 * @author rajeev.k
 * @description This component extends PrimeReact InputText tag (<InputText/>).
 * All properties of PrimeReact InputText can be used by this BeoInputText component.
 */
var BeoInputText = function (_a) {
    var id = _a.id, ref = _a.ref, _b = _a.width, width = _b === void 0 ? "full" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.type, type = _d === void 0 ? "text" : _d, // Default type is "text", can be overridden
    decimalRegex = _a.decimalRegex, props = __rest(_a, ["id", "ref", "width", "className", "type", "decimalRegex"]);
    return (_jsx(_Fragment, { children: _jsx(InputText, __assign({ id: id, ref: ref }, props, { type: type, className: "w-".concat(width, " custom-height  ").concat(className) })) }));
};
export default BeoInputText;
